export const SITE_URL = "https://bamizban.com";

export const ORGANIZATION = {
  name: "بامیزبان",
  alternateName: "Bamizban",
  url: SITE_URL,
  logo: `${SITE_URL}/images/mizban.png`,
  description:
    "Bamizban is a restaurant management and digital dining platform that helps restaurants manage menus, QR ordering, reservations, tables, and customer interactions.",
  // Query string on the Instagram link is a share-tracking token, not part
  // of the canonical profile URL, so it's stripped here.
  sameAs: ["https://www.instagram.com/ba_mizban"],
};
